export const GET_STATUS_WATCHER = "app/ReportAdmin/GET_STATUS_WATCHER"
export const GET_STATUS_SUCCESS = "app/ReportAdmin/GET_STATUS_SUCCESS"
export const GET_STATUS_FAILED = "app/ReportAdmin/GET_STATUS_FAILED"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/ReportAdmin/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/ReportAdmin/GET_MEASURE_COLOR_RANGE_SUCCESS"
export const GET_MEASURE_COLOR_RANGE_FAILED =
  "app/ReportAdmin/GET_MEASURE_COLOR_RANGE_FAILED"

export const GET_MEASURE_TOTAL_WATCHER =
  "app/ReportAdmin/GET_MEASURE_TOTAL_WATCHER"
export const GET_MEASURE_TOTAL_SUCCESS =
  "app/ReportAdmin/GET_MEASURE_TOTAL_SUCCESS"
export const GET_MEASURE_TOTAL_FAILED =
  "app/ReportAdmin/GET_MEASURE_TOTAL_FAILED"

export const GET_MEASURE_GENERAL_WATCHER =
  "app/ReportAdmin/GET_MEASURE_GENERAL_WATCHER"
export const GET_MEASURE_GENERAL_SUCCESS =
  "app/ReportAdmin/GET_MEASURE_GENERAL_SUCCESS"
export const GET_MEASURE_GENERAL_FAILED =
  "app/ReportAdmin/GET_MEASURE_GENERAL_FAILED"

export const SAVE_CONFIG_BENCHMARK_WATCHER =
  "app/ReportAdmin/SAVE_CONFIG_BENCHMARK_WATCHER"
export const SAVE_CONFIG_BENCHMARK_SUCCESS =
  "app/ReportAdmin/SAVE_CONFIG_BENCHMARK_SUCCESS"
export const SAVE_CONFIG_BENCHMARK_FAILED =
  "app/ReportAdmin/SAVE_CONFIG_BENCHMARK_FAILED"
